import { infiniteHits as infiniteHitsWidget} from 'instantsearch.js/es/widgets'

export const siteInfiniteHits = infiniteHitsWidget({
  container: '#hits',
  escapeHTML: true,
  cssClasses: {
    loadMore: 'hidden'
  },
  templates: {
    item: `
        <article class="my-3 pb-3 ml-1.5 border-b border-gray-300 text-sm">
            <a href="{{url}}">
                {{#image}}<img src="{{image}}" alt="">{{/image}}
                <h3>{{#helpers.highlight}}{ "attribute": "title", "highlightedTagName": "mark" }{{/helpers.highlight}} [{{typeLabel}}]</h3>
            </a>
        </article>`
  }
})
